import { AppRouteNames } from "@/shared/@types/AppRouteNames";

const PageNotFoundView = () =>
  import("@/shared/views/PageNotFoundView/PageNotFoundView.vue");
const StartView = () =>
  import("@/app/admin-control-center/start/StartView/StartView.vue");

export const routes = [
  {
    path: "",
    name: AppRouteNames.AdminControlCenterStart,
    meta: {
      titleKey: "adminControlCenter.start.title",
    },
    component: StartView,
  },
  {
    path: ":pathMatch(.*)*",
    name: AppRouteNames.AdminControlCenterNotFound,
    component: PageNotFoundView,
    props: {
      homeRouteName: AppRouteNames.AdminControlCenterStart,
    },
  },
];
